import type { ReactNode } from 'react'
import React, { useEffect } from 'react'
import { Modal, useModalState } from '@vtex/admin-ui'
import { useIntl } from 'react-intl'

export type SalesAssociateMovementsTrackingModalProps = {
  isOpen: boolean
  children: ReactNode
}

export const SalesAssociateMovementsTrackingModal = ({
  isOpen,
  children,
}: SalesAssociateMovementsTrackingModalProps) => {
  // TODO: admin-ui modal won't work without animated: true. Its better to not have animations
  // on Turn List since clients tablet are slow. Check with Onda team how to disable animations
  const blockModal = useModalState()
  const intl = useIntl()

  useEffect(() => {
    if (isOpen) {
      blockModal.show()
    }
  }, [blockModal, isOpen])

  return (
    <Modal
      state={blockModal}
      hideOnInteractOutside={false}
      hideOnEscape={false}
      aria-label={intl.formatMessage({
        id: 'salesAssociateMovementsTrackingModal',
      })}
    >
      {children}
    </Modal>
  )
}
